import { TableHead } from "@/components/ui/table";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

export const SortableHeader = ({ label, sortKey, currentSort, onSort, className = "" }) => {
  const isActive = currentSort?.key === sortKey;
  const isAsc = isActive && currentSort?.dir === "asc";
  const isDesc = isActive && currentSort?.dir === "desc";

  const handleClick = () => {
    if (!isActive) onSort({ key: sortKey, dir: "desc" });
    else if (isDesc) onSort({ key: sortKey, dir: "asc" });
    else onSort(null);
  };

  return (
    <TableHead
      className={`cursor-pointer select-none hover:text-foreground transition-colors group ${className}`}
      onClick={handleClick}
      data-testid={`sort-${sortKey}`}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        {isAsc ? <ArrowUp className="w-3 h-3 text-primary" /> :
         isDesc ? <ArrowDown className="w-3 h-3 text-primary" /> :
         <ArrowUpDown className="w-3 h-3 opacity-0 group-hover:opacity-40 transition-opacity" />}
      </span>
    </TableHead>
  );
};

export const applySorting = (items, sort, getters) => {
  if (!sort) return items;
  const getter = getters[sort.key];
  if (!getter) return items;
  return [...items].sort((a, b) => {
    const va = getter(a) ?? 0;
    const vb = getter(b) ?? 0;
    if (typeof va === "string") return sort.dir === "asc" ? va.localeCompare(vb) : vb.localeCompare(va);
    return sort.dir === "asc" ? va - vb : vb - va;
  });
};
